import React, { Component } from 'react'
import { NavBar,  Space, Toast ,Input,Form,Button} from 'antd-mobile'
import { SearchOutline, MoreOutline, CloseOutline } from 'antd-mobile-icons'
import styles from './login.less'
export default class Login extends Component {
    state={
        phone:'',
    }
    right =(
        <div style={{ fontSize: 24 }}>
          <Space style={{ '--gap': '16px' }}>
            <SearchOutline onClick={this.search}/>
            <MoreOutline onClick={this.clickMore}/>
          </Space>
        </div>
      )
    clickMore = () =>
    Toast.show({
        content: '点击了更多区域',
        duration: 1000,
    })
    search = () =>
    Toast.show({
        content: '点击了查询区域',
        duration: 1000,
    })
    back = () =>
        Toast.show({
          content: '点击了返回区域',
          duration: 1000,
        })
    sendVerifyCode=()=>{
        Toast.show({
            content: '发送了验证码',
            duration: 1000,
          })
    }
    render() {
        const {tel} = this.state
        return (
            <div>
                {/* <NavBar right={this.right} onBack={this.back}> 验证登录 </NavBar>   */}
                <NavBar backArrow={false} onBack={this.back}> 验证登录 </NavBar>  
                <div style={{marginTop:'20px'}}>
                    <Form layout='horizontal'>
                        <Form.Item label='手机号码' name='phone'>
                            <Input placeholder='请输入手机号码' clearable />
                        </Form.Item>
                        <Form.Item
                            label='短信验证码'
                            extra={
                            <div className={styles.extraPart}>
                                <Button color='primary' fill='none' onClick={this.sendVerifyCode}>
                                发送验证码
                                </Button> 
                            </div>
                            }
                        >
                        <Input placeholder='请输入验证码' clearable />
                    </Form.Item>
                    </Form>
                </div>
                <div style={{marginTop:'30px',paddingLeft:'7px',paddingRight:'7px'}}>
                    <Button block color='primary' size='large'>
                        登录
                    </Button>
                </div> 
            </div>
        )
    }
}

